module.exports = __webpack_public_path__ + "static/img/add-rect@2x.1b396771.png";